__turbopack_context__.v({
  "list": "SearchResultsState-module__D2R5AW__list" + " " + __turbopack_context__.i(524956)["list"],
});
